var _circle, _ellipse, _path, _path2, _path3, _path4, _ellipse2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLandmarksBotGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8222,
    cy: 41.8761,
    rx: 12.4118,
    ry: 12.4454,
    transform: "rotate(90 19.8222 41.8761)",
    fill: "#505862"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.0639 62.6221C66.5409 62.6221 63.6876 59.7743 63.6876 56.2646C63.6876 52.7548 66.5409 49.907 70.0639 49.907C73.5868 49.907 76.4402 52.7548 76.4402 56.2646C76.4402 59.7743 73.5868 62.6221 70.0639 62.6221Z",
    fill: "white",
    stroke: "#505862",
    strokeWidth: 1.11772
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7026 56.8905C71.4453 56.1497 72.6443 56.1332 73.4073 56.8531L75.9583 59.2598C75.9583 59.2598 75.2307 60.2776 74.6826 60.8593C74.1632 61.4105 73.2462 62.1631 73.2462 62.1631L70.7026 59.6264C69.945 58.8709 69.945 57.646 70.7026 56.8905V56.8905Z",
    fill: "#505862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0639 19.9951C66.5409 19.995 63.6876 22.8429 63.6876 26.3526C63.6876 29.8624 66.5409 32.7102 70.0639 32.7102C73.5868 32.7102 76.4402 29.8624 76.4402 26.3526C76.4402 22.8429 73.5868 19.9951 70.0639 19.9951Z",
    fill: "white",
    stroke: "#505862",
    strokeWidth: 1.11772
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7026 25.7262C71.4453 26.467 72.6443 26.4835 73.4073 25.7636L75.9583 23.3569C75.9583 23.3569 75.2307 22.3391 74.6826 21.7574C74.1632 21.2062 73.2462 20.4536 73.2462 20.4536L70.7026 22.9903C69.945 23.7458 69.945 24.9707 70.7026 25.7262V25.7262Z",
    fill: "#505862"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.5754,
    cy: 41.481,
    rx: 17.3775,
    ry: 17.4246,
    transform: "rotate(90 59.5754 41.481)",
    fill: "#505862"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6134 30.5195C65.1252 34.1593 65.9032 38.0603 65.9032 42L35.822 42L17.3563 42L17.3571 41.9995L6.41202 35.6974C6.79274 33.9305 7.33368 32.1972 8.0305 30.5195C9.54223 26.8797 11.758 23.5726 14.5513 20.7868C17.3446 18.001 20.6607 15.7913 24.3104 14.2836C27.96 12.776 31.8716 12 35.822 12C39.7723 12 43.6839 12.776 47.3336 14.2836C50.9832 15.7913 54.2993 18.001 57.0926 20.7868C59.8859 23.5726 62.1017 26.8797 63.6134 30.5195Z",
    fill: "#67717E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3563 42L6.41164 48.3019C6.79236 50.0691 7.33335 51.8025 8.03027 53.4805C9.54199 57.1203 11.7578 60.4274 14.5511 63.2132C17.3444 65.999 20.6605 68.2087 24.3101 69.7164C27.9598 71.224 31.8714 72 35.8217 72C39.7721 72 43.6837 71.224 47.3333 69.7164C50.983 68.2087 54.2991 65.999 57.0924 63.2132C59.8857 60.4274 62.1015 57.1203 63.6132 53.4805C65.1249 49.8407 65.903 45.9397 65.903 42L35.8217 42L17.3563 42Z",
    fill: "#818A98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1096 41.9805C55.1097 42.0147 55.1098 42.0489 55.1098 42.0831C55.1098 50.5245 51.5041 58.1012 45.7878 63.2781C53.2126 59.2496 58.2725 51.2406 58.2725 42.0182C58.2725 42.0056 58.2725 41.993 58.2725 41.9805L55.1096 41.9805Z",
    fill: "#D5D8DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5114 41.9805C42.5115 42.0068 42.5116 42.0331 42.5116 42.0594C42.5116 48.5528 39.7124 54.3811 35.2748 58.3633C41.0388 55.2644 44.9668 49.1036 44.9668 42.0095C44.9668 41.9998 44.9668 41.9901 44.9668 41.9805L42.5114 41.9805Z",
    fill: "#D5D8DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 41.8164C29.3001 41.8332 29.3001 41.8501 29.3001 41.8669C29.3001 46.0227 27.5447 49.7528 24.7618 52.3014C28.3765 50.3181 30.8398 46.3752 30.8398 41.835C30.8398 41.8288 30.8398 41.8226 30.8398 41.8164L29.3 41.8164Z",
    fill: "#D5D8DD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1096 41.9805C55.1097 41.9476 55.1098 41.9147 55.1098 41.8818C55.1098 33.765 51.5041 26.4797 45.7878 21.502C53.2126 25.3756 58.2725 33.0765 58.2725 41.9442C58.2725 41.9563 58.2725 41.9684 58.2725 41.9805L55.1096 41.9805Z",
    fill: "#9DA4AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5114 41.9805C42.5115 41.9547 42.5116 41.9289 42.5116 41.9031C42.5116 35.5396 39.7124 29.8279 35.2748 25.9253C41.0388 28.9622 44.9668 34.9998 44.9668 41.952C44.9668 41.9615 44.9668 41.971 44.9668 41.9805L42.5114 41.9805Z",
    fill: "#9DA4AF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 41.8164C29.3001 41.8004 29.3001 41.7843 29.3001 41.7682C29.3001 37.8073 27.5447 34.252 24.7618 31.8229C28.3765 33.7132 30.8398 37.4713 30.8398 41.7987C30.8398 41.8046 30.8398 41.8105 30.8398 41.8164L29.3 41.8164Z",
    fill: "#9DA4AF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.9609,
    y: 56.0698,
    width: 13.1062,
    height: 13.1417,
    rx: 6.55311,
    transform: "rotate(90 33.9609 56.0698)",
    fill: "#E06351"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.96,
    y: 14.6216,
    width: 13.1062,
    height: 13.1417,
    rx: 6.55311,
    transform: "rotate(90 33.96 14.6216)",
    fill: "#F1AE5B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLandmarksBotGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LandmarksBotGray.c210e0e9a1a119605aab1d9e78d2d64c.svg";